module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "z-share",
    attrs: {
      "close-on-click-modal": false,
      "size": 'large',
      "title": "职级分配",
      "visible": _vm.popFlag
    },
    on: {
      "close": _vm.deepClear,
      "update:visible": function($event) {
        _vm.popFlag = $event
      }
    }
  }, [_c('div', {
    staticClass: "head-center-text"
  }, [_vm._v(_vm._s(""))]), _vm._v(" "), _c('div', {
    staticClass: "remind"
  }, [_c('p', {
    staticClass: "remind-rank"
  }, [_vm._v("可分配职级：" + _vm._s(_vm.rest_level) + "级")])]), _vm._v(" "), _c('table', {
    staticClass: "RankTable",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('td', [_vm._v("姓名")]), _vm._v(" "), _c('td', [_vm._v("任务数")]), _vm._v(" "), _c('td', [_vm._v("异常任务数")]), _vm._v(" "), _c('td', [_vm._v("罚单数")]), _vm._v(" "), _c('td', [_vm._v("罚币数量(币)")]), _vm._v(" "), _c('td', [_vm._v("职级")]), _vm._v(" "), _c('td', [_vm._v("分配职级")])])]), _vm._v(" "), _c('tbody', {
    directives: [{
      name: "form",
      rawName: "v-form:pmt",
      arg: "pmt"
    }]
  }, _vm._l((_vm.users), function(item, index) {
    return _c('tr', {
      key: item.id
    }, [_c('td', [_vm._v(_vm._s(item.real_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.task_size))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.error_task_size))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ticket_size))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.ticket_sum))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.staffing_grade))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "tar",
        rawName: "v-tar",
        value: (_vm.sub_arr[index]),
        expression: "sub_arr[index]"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.sub_arr[index]),
        expression: "sub_arr[index]"
      }],
      attrs: {
        "type": "text",
        "rule": "bonus"
      },
      domProps: {
        "value": (_vm.sub_arr[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.sub_arr, index, $event.target.value)
        }
      }
    })])])
  }))]), _vm._v(" "), _c('p', {
    staticClass: "bonusNotice"
  }, [_vm._v("注*异常任务指的是执行中被取消的任务")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.popFlag = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.pmt_confirm
    }
  }, [_vm._v("完成")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-5b5a6361!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/frontStage/buManage/rankShare.vue
// module id = 749
// module chunks = 1